import request from "@/utils/axios";


//  平台授权接口
export function AUTH(data) {
    return request({
        url: '/api/platform/auth',
        method: 'post',
        data
    })
}

// 多平台-BI看板点击数
export function QUERYCLICKSDETAIL(data) {
    return request({
        url: '/api/platformbi/queryClicksDetail',
        method: 'get',
        data
    })
}
// 多平台-BI看板出单量
export function QUERYORDERDATADETAIL(data) {
    return request({
        url: '/api/platformbi/queryOrderDataDetail',
        method: 'get',
        data
    })
}
// BI看板分销金额
export function QUERYAMOUNTDATADETAIL(data) {
    return request({
        url: '/api/platformbi/queryAmountDataDetail',
        method: 'get',
        data
    })
}

//  【多平台管理】BI看板-数据概览-分销订单数图表-分销金额图表
export function QUERYAMOUNTCOUNTCHART(data) {
    return request({
        url: '/api/platformbi/queryAmountCountChart',
        method: 'post',
        data
    })
}
//  【多平台管理】BI看板-重复订单-重复订单数图表-重复分销金额图表
export function QUERYREPEATORDERCHART(data) {
    return request({
        url: '/api/platformbi/queryRepeatOrderChart',
        method: 'post',
        data
    })
}
//  【多平台管理】BI看板-联盟客top5
export function QUERYTOP5DATA(data) {
    return request({
        url: '/api/platformbi/queryTop5Data',
        method: 'post',
        data
    })
}
// 【多平台管理】BI看板-联盟客类型分销占比
export function QUERYAFFLIATETYPERATE(data) {
    return request({
        url: '/api/platformbi/queryAffliateTypeRate',
        method: 'post',
        data
    })
}
// 【多平台管理】BI看板-重复订单占比
export function QUERYREPEATRATE(data) {
    return request({
        url: '/api/platformbi/queryRepeatRate',
        method: 'post',
        data
    })
}
// 【多平台管理】列表-订单详情
export function QUERYORDERDETAILLIST(data) {
    return request({
        url: '/api/platformlist/queryOrderDetailList',
        method: 'post',
        data
    })
}
// 【多平台管理】列表-联盟客详情
export function QUERYAFFILIATEDETAILLIST(data) {
    return request({
        url: '/api/platformlist/queryAffiliateDetailList',
        method: 'post',
        data
    })
}
// 【多平台管理】列表-重合订单（数据概览）
export function QUERYREPEATDETAILLIST(data) {
    return request({
        url: '/api/platformlist/queryRepeatDetailList',
        method: 'post',
        data
    })
}
// 授权列表清单
export function QUERYPLATFORMLIST(data) {
    return request({
        url: '/api/platform/queryPlatformList',
        method: 'get',
        data
    })
}
//【多平台管理】列表-重合订单（联盟客概览
export function QUERYREPEATBDETAILLIST(data) {
    return request({
        url: '/api/platformlist/queryRepeatBDetailList',
        method: 'post',
        data
    })
}

//平台信息
export function HASPLATFORMLIST(data) {
    return request({
        url: '/api/platform/hasPlatformList',
        method: 'get',
        data
    })
}